import React, { PropTypes } from 'react';
import ManagerEditForm from '../ManagerEditForm';

class ManagersNew extends React.Component {
  static propTypes = {
    fetch: PropTypes.func.isRequired
  };

  componentWillMount() {
    this.props.fetch();
  }

  render() {
    return (
        <ManagerEditForm title="New Manager" {...this.props}/>
    )
  }
}

export default ManagersNew;



// WEBPACK FOOTER //
// ./src/components/Managers/ManagersNew/component.jsx